'use strict';

module.exports = [
  AssignmentStatusService];

function AssignmentStatusService() {

}

Object.defineProperty(AssignmentStatusService, 'STATUSES', {
  value: [
    'not_scheduled',
    'scheduled',
    'imminent',
    'past_due',
    'complete',
  ],
});



// WEBPACK FOOTER //
// ./src/js/calendar/AssignmentStatusService.js